import {useParams} from 'react-router-dom';
import {useSelector} from 'react-redux';

import Headings from '../components/ui/containers/Headings/Headings';

import ActionsBar from '../components/ui/containers/ActionsBar/ActionsBar';

import Agenda from '../components/layout/Agenda/Agenda';

import NoMatch from './NoMatch';
import {push} from '../helpers/seo';

import Text from '../components/layout/Text/Text';

import {useState} from 'react';
import {useTranslation} from 'react-i18next';

import styles from './Global.module.scss';

const SpotifyIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1333.33 1333.3">
      <path
        d="M666.66 0C298.48 0 0 298.47 0 666.65c0 368.19 298.48 666.65 666.66 666.65 368.22 0 666.67-298.45 666.67-666.65C1333.33 298.49 1034.88.03 666.65.03l.01-.04zm305.73 961.51c-11.94 19.58-37.57 25.8-57.16 13.77-156.52-95.61-353.57-117.26-585.63-64.24-22.36 5.09-44.65-8.92-49.75-31.29-5.12-22.37 8.84-44.66 31.26-49.75 253.95-58.02 471.78-33.04 647.51 74.35 19.59 12.02 25.8 37.57 13.77 57.16zm81.6-181.52c-15.05 24.45-47.05 32.17-71.49 17.13-179.2-110.15-452.35-142.05-664.31-77.7-27.49 8.3-56.52-7.19-64.86-34.63-8.28-27.49 7.22-56.46 34.66-64.82 242.11-73.46 543.1-37.88 748.89 88.58 24.44 15.05 32.16 47.05 17.12 71.46V780zm7.01-189.02c-214.87-127.62-569.36-139.35-774.5-77.09-32.94 9.99-67.78-8.6-77.76-41.55-9.98-32.96 8.6-67.77 41.56-77.78 235.49-71.49 626.96-57.68 874.34 89.18 29.69 17.59 39.41 55.85 21.81 85.44-17.52 29.63-55.89 39.4-85.42 21.8h-.03z"
        fill="currentColor"/>
    </svg>
  );
};

const YoutubeIcon = () => {
  return (
    <svg width="64" height="64"
         viewBox="0 0 640 640">
      <path
        d="M633.468 192.038s-6.248-44.115-25.477-63.485c-24.366-25.477-51.65-25.642-64.123-27.118-89.493-6.52-223.904-6.52-223.904-6.52h-.236s-134.352 0-223.893 6.52c-12.52 1.523-39.768 1.63-64.123 27.118-19.24 19.37-25.358 63.485-25.358 63.485S-.012 243.806-.012 295.681v48.509c0 51.768 6.366 103.643 6.366 103.643s6.248 44.114 25.358 63.52c24.355 25.477 56.363 24.65 70.655 27.367 51.237 4.89 217.644 6.366 217.644 6.366s134.529-.237 224.022-6.638c12.52-1.477 39.756-1.63 64.123-27.119 19.24-19.37 25.476-63.532 25.476-63.532S640 396.03 640 344.154v-48.508c-.13-51.769-6.497-103.643-6.497-103.643l-.035.035zm-379.8 211.007V223.173L426.56 313.41l-172.892 89.635z"/>
    </svg>
  );
};

const WebsiteIcon = () => {
  return (
    <svg
      viewBox="0 0 509 511.54">
      <path
        d="M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z"/>
    </svg>
  );
};

const AppleMusicIcon = () => {
  return (
    <svg version="1.1" width="32" height="32" viewBox="0 0 32 32">
      <path
        d="M31.995 8.167c0-0.984-0.083-1.964-0.318-2.922-0.422-1.745-1.417-3.078-2.906-4.057-0.766-0.5-1.609-0.807-2.505-0.969-0.688-0.125-1.385-0.182-2.083-0.198-0.052-0.005-0.109-0.016-0.167-0.021h-16.031c-0.203 0.016-0.406 0.026-0.609 0.036-0.995 0.057-1.984 0.161-2.922 0.536-1.781 0.703-3.068 1.932-3.818 3.703-0.26 0.599-0.391 1.234-0.484 1.88-0.078 0.521-0.12 1.047-0.135 1.573 0 0.042-0.010 0.083-0.010 0.125v16.297c0.010 0.188 0.021 0.375 0.031 0.563 0.068 1.089 0.208 2.167 0.667 3.167 0.865 1.891 2.318 3.135 4.313 3.734 0.557 0.172 1.141 0.25 1.724 0.302 0.74 0.073 1.479 0.083 2.219 0.083h14.708c0.698 0 1.396-0.047 2.094-0.135 1.099-0.141 2.13-0.464 3.063-1.078 1.12-0.74 1.964-1.719 2.505-2.943 0.25-0.563 0.391-1.161 0.495-1.766 0.151-0.901 0.182-1.813 0.182-2.724-0.005-5.063 0-10.125-0.005-15.188zM23.432 13.484v7.615c0 0.557-0.078 1.104-0.328 1.609-0.385 0.786-1.010 1.281-1.849 1.521-0.464 0.135-0.943 0.208-1.427 0.229-1.266 0.063-2.365-0.797-2.589-2.047-0.193-1.031 0.302-2.167 1.385-2.698 0.427-0.208 0.891-0.333 1.354-0.427 0.505-0.109 1.010-0.208 1.51-0.323 0.37-0.083 0.609-0.307 0.682-0.688 0.021-0.083 0.026-0.172 0.026-0.255 0-2.422 0-4.844 0-7.26 0-0.083-0.016-0.167-0.036-0.245-0.052-0.203-0.198-0.323-0.406-0.313-0.214 0.010-0.422 0.047-0.63 0.089-1.016 0.198-2.031 0.401-3.042 0.609l-4.932 0.995c-0.021 0.005-0.047 0.016-0.068 0.016-0.37 0.104-0.5 0.271-0.516 0.656-0.005 0.057 0 0.115 0 0.172-0.005 3.469 0 6.938-0.005 10.406 0 0.563-0.063 1.115-0.286 1.635-0.37 0.854-1.026 1.391-1.911 1.646-0.469 0.135-0.948 0.214-1.438 0.229-1.276 0.047-2.339-0.802-2.557-2.057-0.188-1.083 0.307-2.25 1.536-2.771 0.479-0.198 0.974-0.307 1.479-0.411 0.38-0.078 0.766-0.156 1.146-0.234 0.51-0.109 0.776-0.432 0.802-0.953v-0.198c0-3.948 0-7.896 0-11.844 0-0.167 0.021-0.333 0.057-0.495 0.094-0.38 0.365-0.599 0.729-0.688 0.339-0.089 0.688-0.151 1.031-0.224 0.979-0.198 1.953-0.396 2.932-0.589l3.026-0.615c0.896-0.177 1.786-0.359 2.682-0.536 0.292-0.057 0.589-0.12 0.885-0.141 0.411-0.036 0.698 0.224 0.74 0.641 0.010 0.099 0.016 0.198 0.016 0.297 0 2.547 0 5.094 0 7.641z"></path>
    </svg>
  );
};

function Artist() {
  const {t} = useTranslation('artist');

  const [agendaCount, setAgendaCount] = useState(0);

  const {slug} = useParams();
  const content = useSelector(state => state.content.value);
  const artist = content.artists.find(artist => artist.slug === slug);

  if (!artist) {
    return (<NoMatch/>);
  }

  const image = artist.image.filter(image => image.key === 'banner')[0].url;

  const actions = [];
  if (artist.spotify_link) {
    actions.push({
      label: 'Spotify',
      url:   artist.spotify_link,
      icon:  <SpotifyIcon/>
    });
  }
  if (artist.youtube_link) {
    actions.push({
      label: 'Youtube',
      url:   artist.youtube_link,
      icon:  <YoutubeIcon/>
    });
  }
  if (artist.apple_music_link) {
    actions.push({
      label: 'Apple Music',
      url:   artist.apple_music_link,
      icon:  <AppleMusicIcon/>
    });
  }
  if (artist.website_link) {
    actions.push({
      label: 'Website',
      url:   artist.website_link,
      icon:  <WebsiteIcon/>
    });
  }

  push({
    title:       artist.name,
    description: artist.description,
    keywords:    artist.name + ', artist, music, concert, show, event, ticket, copprart, coppr, art'
  });

  const service_email = artist.service_email ? artist.service_email : 'nicolas@copprart.be';

  return (
    <div>
      <Headings title={artist.name} image={image}/>

      {actions.length > 0 && (<ActionsBar actions={actions}/>)}

      <div className={styles.content}>
        {artist.description && artist.description.split("\n").map((paragraph, index) => (
          <Text key={index} gutter={true}>
            {paragraph}
          </Text>
        ))}

        <br/> <br/>

        <Text gutter={true} tag="h2" weight="bold" size="large" type="separator">
          {t('contact.title')}
        </Text>
        <Text gutter={true}>
          {(artist.services && artist.services.length ? (artist.services.join(' + ') + ': ') : null)}
          <a href={`mailto:${service_email}`}>{service_email}</a>
        </Text>

        <br/> <br/>

        {agendaCount > 0 && (
          <Text gutter={true} tag="h2" weight="bold" size="large" type="separator">
            {t('agenda.title')} ({agendaCount})
          </Text>
        )}

        <Text gutter={true} tag="div">
          <Agenda setAgendaCount={setAgendaCount} artist_slug={artist.slug}/>
        </Text>
      </div>
    </div>
  );
}

export default Artist;